import script from "./ReviewFormView.vue?vue&type=script&setup=true&lang=js"
export * from "./ReviewFormView.vue?vue&type=script&setup=true&lang=js"

import "./ReviewFormView.vue?vue&type=style&index=0&id=12cf6423&scoped=true&lang=css"
import "./ReviewFormView.vue?vue&type=style&index=1&id=12cf6423&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12cf6423"]])

export default __exports__